import { Injectable } from '@angular/core';
import { BaseProductService } from './base-product.service';
import { IProductBase, IProductCreationParams, IProductDeleteParams, IProductReservationBase, IProductReservationParams, Profility } from 'model/product.interface';
import { IExperiencieProduct, PayloadUpdateExperience, ReservationIExperienceProduct } from 'model/experience-product.interface';
import { keyRandomUnique } from 'utils/helpers';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExperienceProductService extends BaseProductService {

  private readonly CATEGORY_ID = 6;
  private readonly SUB_CATEGORY_ID = 6;
  private readonly CATEGORY_NAME = 'TOURS';
  private readonly SUB_CATEGORY_NAME = 'EXPERIENCE';

  private form: any;

  createProduct(params: IProductCreationParams): IProductBase {

    const { item, product, payload, othersPerCategory } = params;

    if(!this.form) {
      this.form = JSON.parse(localStorage.getItem('form'));
    }

    if(othersPerCategory.suggestion) {
      console.log(payload)
      this.form = {
          arrivalDateDepartureDate : {},
          destination: {
            airport_iatas: [],
            city_name: payload[0].city,
            city_iata_code: payload[0].destination,
            country_iata_code: '',
            id: '',
            inmg_zones: [],
            pic_mini: "",

          },
          qtyAdutls: payload[0].others.tours.adults,
          qtyChilds: payload[0].others.tours.children.length,
          childsAges: othersPerCategory.childAges,
      }
      console.log(this.form);
    }


    this.commonsValueProduct(item, product, payload, this.form, othersPerCategory);
    this.setupExperienceSpecificProperties(item, product,payload, this.form, othersPerCategory);
    item.payloadUpdate = this._payloadUpdateExperience(payload, item, product, othersPerCategory);
    item.destination = this.itineraryService.getDestinationInfo(this.form, item);


    return item as IExperiencieProduct;
  }

  validateProduct(item: any): boolean {
    throw new Error('Method not implemented.');
  }

  private commonsValueProduct(item: any, product: any, payload: any, form: any, othersData: any): void {

      item.id = product.optionId;
      item.searchId = othersData.searchId;
      item.providerId = item.providerId;
      item.from = othersData.from || '';
      item.providerName = item?.providerName;
      item.categoryName = this.CATEGORY_NAME;
      item.subCategoryId = this.SUB_CATEGORY_ID;
      item.subCategoryName = this.SUB_CATEGORY_NAME;
      item.currency = product.currency;
      item.nameAdapter = item?.nameAdapter;
      item.updateDate = new Date();
  }

  private setupExperienceSpecificProperties(item: any, product: any, payload: any, form: any, othersData: any): void {

        const cancellationPolicies = this.getCancellationPolicies(product, othersData.arrivalDate);

        item.tourId = item?.tourId;
        item.idProduct = product.optionId;
        item.location = item.location;
        item.form = form;
        item.arrivalDate = othersData.arrivalDate;
        item.hasReservationQuestions = item.additionalInfo?.tours?.hasReservationQuestions;
        item.questions = product.questions;
        item.company = item.additionalInfo?.tours?.company;
        item.amenities = item.additionalInfo?.tours?.amenities || [];
        item.addonsIncluded = product.addonsIncluded || [];
        item.images = item.additionalInfo?.images;
        item.selectDay = othersData.arrivalDate;
        item.productKey = keyRandomUnique();
        item.payload = payload;
        item.bookParam = product.bookParam;
        item.origin = product.origin;
        item.experience = product;
        item.cancellationPolicies = cancellationPolicies;
        item.expiration_date = cancellationPolicies.cancellationPolicies && cancellationPolicies.cancellationPolicies.length > 0
                           ? (cancellationPolicies.cancellationPolicies.dateFrom || this.adjustDate(cancellationPolicies.cancellationPolicies[0].dateFrom, -1))
                           : othersData.arrivalDate;
        item.paxNumber = othersData.paxNumber;
        item.rateClassId = product.rateClass;
        item.paxesData = othersData.paxesData;

        item.netPriceUnitary = Number(item.paxesData.reduce((sum, price) => sum + (price.originalAmount * price.passengerCount), 0).toFixed(2));
        item.netPriceFreeTax = Number(item.paxesData.reduce((sum, price) => sum + (price?.pricing?.netPriceFreeTax || 0), 0).toFixed(2));
        item.netPrice = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.netPrice), 0).toFixed(2));
        item.totalPriceProf = Number(item.paxesData.reduce((sum, price) => sum + (price.total || 0), 0).toFixed(2));
        item.totalPrice = Number(item.paxesData.reduce((sum, price) => sum + (price.total || 0), 0).toFixed(2));
        item.blickoins = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.blickoins), 0).toFixed(2));
        item.creditBlickoins = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.creditBlickoins), 0).toFixed(2));

        item.netPriceFreeTax = item.experience.netPriceBookingAddons ? item.netPriceFreeTax + item.experience.netPriceBookingAddons : item.netPriceFreeTax;
        item.totalPriceProf = item.experience.netPriceBookingAddons ? item.totalPriceProf + item.experience.netPriceBookingAddons : item.totalPriceProf;
        item.netPrice = item.experience.netPriceBookingAddons ? item.netPrice + item.experience.netPriceBookingAddons : item.netPrice;
        item.totalPrice = item.experience.netPriceBookingAddons ? item.totalPrice + item.experience.netPriceBookingAddons : item.totalPrice;

        item.taxes = product.taxes ? product.taxes : [];
        item.taxPrice = product.taxPrice ? product.taxPrice : 0;
        item.tax = product.tax ? product.tax : 0;
        item.taxPriceNightTotal = 0;

        item.profilityOriginal = product.profility;
        item.pricingOriginal = product.pricing;

        item.paxesData = othersData.paxesData;

        item.paxProfility = item.paxesData.map(pax => pax.profility) || null;
        item.paxPricing = item.paxesData.map(pax => pax.pricing) || null;

        item.serviceExtra = this.getServiceExtra(item);

        item.profility = this.getProfility(item);

        item.pricing = this.getPricing(item);

        if(othersData.hourSelectHidden) {
          item.title = item.title;
          item.productName = item.experience.option_name;
          item.departureDate = othersData.arrivalDate;
        } else {
          item.title = item.title;
          item.productName = item.experience.option_name;

          if(product?.duration.slice('-')[0] === '1') {
            item.departureDate = item.departureDate = othersData.arrivalDate;
          } else {
              if(product.duration || product.duration !== '') {
                let days = parseInt(product.duration.split('-')[0].trim()); // Obtener el número de días

                if(!days) {
                  days = 1;
                  console.info('"Falta durations"');
                }


                const arrivalDate = new Date(othersData.arrivalDate);

                // Sumar la cantidad de días -1 porque el primer día ya es la fecha de llegada
                arrivalDate.setDate(arrivalDate.getDate() + (days - 1));

                // Formatear de nuevo a YYYY-MM-DD

                  item.departureDate = arrivalDate.toISOString().split('T')[0];
              } else {
                console.info('falta "duration" en la respuesta');
              }
          }
        }

        item.adults = item.paxesData.find(c => c.paxType === 'ADULT').passengerCount;
        item.childrens = othersData.childAges.length;

        item.additionalInfo.tours.options = [];

      }

      private adjustDate(date: string | Date, days: number): string {
        if (!date) return '';

        // Convertir Date a string si es necesario
        let dateStr: string;
        if (typeof date === 'string') {
          dateStr = date;
        } else {
          // Asumiendo que es un objeto Date
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          dateStr = `${year}-${month}-${day}`;
        }

        const d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        return d.toISOString().split('T')[0];
      }

    private getCancellationPolicies(productExperience: any, selectDay: any): any {

      return productExperience.cancellationPolicies.find(c => c.from === selectDay);

    }

    private getServiceExtra(item: any): any[] {

    let arr: any[] = [];

    if(item.experience.addonsIncluded && item.experience.addonsIncluded.length > 0) {
      item.experience.addonsIncluded.forEach((addons: any) => {
        arr.push({
          name: addons.description,
          price: addons.totalPrice
        });
      });
    }

    return arr;
  }

  private getProfility(item: any): Profility {
    return {
        blickoins: Number(item.paxProfility.reduce((sum, price) => sum + (price.blickoins || 0), 0).toFixed(2)),
        creditBlickoins: Number(item.paxProfility.reduce((sum, price) => sum + (price.creditBlickoins || 0), 0).toFixed(2)),
        netPrice: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPrice || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
        netPriceBooking: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceBooking || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
        netPriceCategory: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceCategory || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
        netPriceProvider: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceProvider || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
        percentage: item.paxProfility[0].percentage || 0,
        percentageBooking: item.paxProfility[0].percentageBooking || 0,
        percentageCategory: item.paxProfility[0].percentageCategory || 0,
        percentageProvider: item.paxProfility[0].percentageProvider || 0
        };
  }

  private getPricing(item: any): any {
    return {
            blickoins: Number(item.paxPricing.reduce((sum, price) => sum + (price.blickoins || 0), 0).toFixed(2)),
            creditBlickoins: Number(item.paxPricing.reduce((sum, price) => sum + (price.creditBlickoins || 0), 0).toFixed(2)),
            netPriceFreeTax: Number(item.paxPricing.reduce((sum, price) => sum + (price.netPriceFreeTax || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
            netPriceProf: Number(item.paxPricing.reduce((sum, price) => sum + (price.netPriceProf || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
            totalPriceFreeTax: Number(item.paxPricing.reduce((sum, price) => sum + (price.totalPriceFreeTax || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
            totalPriceProf: Number(item.paxPricing.reduce((sum, price) => sum + (price.totalPriceProf || 0), 0).toFixed(2)) + item.experience?.netPriceBookingAddons,
            percentage: item.paxPricing[0].percentage || 0,
            creditFactor: item.paxPricing[0].creditFactor,
            blickoinsFactor: item.paxPricing[0].blickoinsFactor,
    }
  }

  private _payloadUpdateExperience(payload: any, item: any, product: any, othersData: any): PayloadUpdateExperience {

        let others;
        let payloadUpdate: PayloadUpdateExperience;

         others = {
                agedriver: environment.agedriver,
                serialized: environment.serialized,
                maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
                minNumResults: environment.minNumResults,
                maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
                tours: othersData.payloadUpdate.others !== undefined ? othersData.payloadUpdate.others.tours : othersData.payloadUpdate.products[0].others,
        };

            payloadUpdate = {
              products: [
                {
                  market: 2, // de momento lo seteamos
                  providerId: item.providerId, // momentaneamente: Urgente pedir el providerId del producto item.providerId,
                  nameAdapter: item.nameAdapter,
                  categoriesId: [6], // experiencia-tickets
                  productId: item.productId,
                  productName: item.experience.option_name,
                  destination: payload[0].destination,
                  priceFrom: null,
                  priceTo: null,
                  arrivalDate: othersData.arrivalDate,
                  departureDate: othersData.arrivalDate,
                  others: others,
                  agencyId: othersData.userService._agencyID,
                  bookingCode: product.bookParam,
                  id: product.optionId,
                },
              ],
            };

            if(item.subCategoryId === 6) {
              payloadUpdate["products"][0]["others"]["tours"]["adults"] = item.paxesData.find(c => c.paxType === 'ADULT').passengerCount;
              payloadUpdate["products"][0]["others"]["tours"]["children"] = othersData.childAges;
            }

            return payloadUpdate;
  }

  createReserve(params: IProductReservationParams): IProductReservationBase {

      const { item, paxes, itineraryId, othersPerCategory } = params;

      return item as ReservationIExperienceProduct;
  }

  deleteProduct(params: IProductDeleteParams): any {

    const { item } = params;



  }


}
